package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.repository.RouteRepository

/**
 * DELETE /api/v1/routes/{id} — logical delete of a not-yet-started route (MIL-65, écran 07
 * Accueil Livreur). See [RouteRepository.deleteRoute].
 */
class DeleteRouteUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(id: String) = repository.deleteRoute(id)
}
